"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseHierarchyUtil = void 0;
var Constants_1 = require("../Constants");
var types_1 = require("../types");
var HierarchyUtil_1 = require("../util/HierarchyUtil");
var BaseHierarchyUtil = /** @class */ (function () {
    function BaseHierarchyUtil() {
        this._openName = 'Open';
    }
    BaseHierarchyUtil.prototype.getNodeDataName = function (nodeVm, hierarchyEditState) {
        var _a, _b;
        var nodeData = nodeVm.nodeData, nodeId = nodeVm.nodeId;
        if ((0, HierarchyUtil_1.isMovingNodes)(hierarchyEditState)) {
            var selectedDestinationNodeId = hierarchyEditState.selectedDestinationNodeId, replaceDestination = hierarchyEditState.replaceDestination, selectedNodeDataName = hierarchyEditState.selectedNodeDataName;
            // If previewing a node replacement
            if (selectedDestinationNodeId === nodeId && replaceDestination && !nodeData && selectedNodeDataName) {
                // Show the data name of the node it is being replaced with
                return selectedNodeDataName;
            }
        }
        return (_b = (_a = nodeVm.nodeData) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
    };
    BaseHierarchyUtil.prototype.isValidMoveDestination = function (node, moving, parentIds) {
        // The destination cannot be the node being moved
        if (node.nodeId === moving.nodeId) {
            return false;
        }
        // An orphan moved to an orphaned placeholder is a no-op.
        if (moving.isOrphan && node.nodeId === Constants_1.Constants.ORPHAN_PLACEHOLDER_ID) {
            return false;
        }
        return true;
    };
    BaseHierarchyUtil.prototype.nodeDisplayName = function (nodeVm, hierarchyEditState, format) {
        var nodeId = nodeVm.nodeId, nodeName = nodeVm.name, nodeLoaded = nodeVm.fullyLoaded;
        if (nodeId === Constants_1.Constants.ORPHAN_PLACEHOLDER_ID && !nodeLoaded) {
            return nodeName !== null && nodeName !== void 0 ? nodeName : '';
        }
        return format(nodeName !== null && nodeName !== void 0 ? nodeName : '', this.getPersonName(nodeVm, hierarchyEditState));
    };
    BaseHierarchyUtil.prototype.getPersonName = function (nodeVm, hierarchyEditState) {
        // If previewing a move operation, wherein the node being moved will remain an open position
        if (nodeVm.editState && nodeVm.editState === types_1.NodeMoveState.MoveKeepOpen) {
            // Display the open name for the node
            return this._openName;
        }
        return this.getNodeDataName(nodeVm, hierarchyEditState) || this._openName;
    };
    return BaseHierarchyUtil;
}());
exports.BaseHierarchyUtil = BaseHierarchyUtil;
